import { render, staticRenderFns } from "./Upfaceimg.vue?vue&type=template&id=dd2208c0&scoped=true"
import script from "./Upfaceimg.vue?vue&type=script&lang=js"
export * from "./Upfaceimg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2208c0",
  null
  
)

export default component.exports